<template>
    <div class="dispatch-sites-grid">
        <div v-if="loading" class="loading-overlay">
            LOADING...
            <span class="loader"></span>
        </div>

        <TankStatusGrid v-else :data-source="containers" :properties="properties"
            key-expr="containerId" :state-storage-key="storageKey"
            :default-column-config="defaultColumnConfig" :column-fixing-enabled="true"
            :height-offset="360" :use-default-column-config-only="false"
            :selection="selection" :show-status-filters="false"
            @grid-initialized="setGridInstance" @content-ready="onContentReady"
            @selection-changed="onSelectionChanged" @refresh-data="refreshData" />
    </div>
</template>

<script>
import TankStatusGrid from '@/components/container/tank-status-grid.vue';

export default {
    name: 'DispatchSitesGrid',
    components: {
        TankStatusGrid,
    },
    data() {
        return {
            dataGridInstance: null,
            defaultSelectionApplied: false,
            selection: {
                mode: 'multiple',
                showCheckBoxesMode: 'always',
                allowSelectAll: true,
            },
        };
    },
    computed: {
        storageKey() {
            return 'dispatch-builder-sites';
        },
        loading() {
            // Containers are loaded up front by the builder; until the status
            // data lands (containersV2 goes from undefined to an array), show
            // the loading state.
            return this.$store.getters['containers/getContainersV2'] == null;
        },
        containers() {
            return this.$store.getters['dispatch/getFilteredContainers'];
        },
        properties() {
            return this.$store.getters['dispatch/getProperties'];
        },
        defaultColumnConfig() {
            return {
                operator: { visible: true, caption: 'Operator', minWidth: 125, alignment: 'left' },
                area: { visible: true, caption: 'Area', minWidth: 125, alignment: 'left' },
                devices: { visible: true, caption: 'Devices', minWidth: 125, alignment: 'left' },
                surface: {
                    visible: true,
                    caption: 'Surface',
                    minWidth: 150,
                    alignment: 'left',
                    allowReordering: true,
                },
            };
        },
    },
    methods: {
        setGridInstance(e) {
            this.dataGridInstance = e.component;
        },
        onContentReady() {
            // Select all sites by default the first time data is ready, unless the
            // dispatch already has a selection (e.g. set via the map picker or a
            // loaded dispatch).
            if (this.defaultSelectionApplied || !this.dataGridInstance) return;
            this.defaultSelectionApplied = true;

            const saved = this.$store.getters['dispatch/getCurrentDispatchSites'] || [];
            if (saved.length) {
                const keys = saved.map((s) => s.containerId);
                this.dataGridInstance.selectRows(keys, false);
            } else {
                this.dataGridInstance.selectAll();
            }
        },
        onSelectionChanged(e) {
            // Keep the store in sync so the count, map picker and later steps
            // always reflect the current selection.
            this.$store.dispatch('dispatch/setSelectedSites', e.selectedRowsData || []);
        },
        refreshData() {
            this.defaultSelectionApplied = false;
            this.$store.dispatch('dispatch/loadContainersStatus', { typeId: 1 });
        },
    },
};
</script>

<style scoped>
.dispatch-sites-grid {
    min-height: 200px;
}
</style>
